import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../helper/shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../project/project.service'; //Mocdified by PP(2022-03-11) : CleanAMC Save & Load Calculation
import { UserInfoService } from '../user-info/user-info.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmationdialogue',
  templateUrl: './confirmationdialogue.component.html',
  styleUrls: ['./confirmationdialogue.component.scss']
})
export class ConfirmationdialogueComponent implements OnInit {
  @Input() title: string = "";
  @Input() message: string = "";
  @Input() btnOkText: string = "";
  @Input() btnCancelText: string = "";

  saving = false;

  constructor(
    private activeModal: NgbActiveModal,
    private sharedService: SharedService,
    private toast: ToastrService,
    public projectService: ProjectService, //Modified by PP(2022-03-11) : CleanAMC Save & Load Calculation
    private userInfoService: UserInfoService,
    private router: Router
  ) { }

  //results;

  //Modified by PS(2023-01-09): Requested by Ulf(2022-12) : LCC3.0 - Auto save the project and name it 'last project' when click to back to home link-START
  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
  // msg1 = 'Do you want to save your changes?'; //Auto save
  // msg2 = 'Project Already Exist. Overwrite?'; //Save As for Overwrite
  // msg3 = 'Do you really want to save the project?'; //Save As
  msg1 = 'Do you want to save your changes?'; //Auto save
  msg2 = 'Project Already Exist. Overwrite?';
  msg3 = 'Do you really want to insert changes?'; // Results - Save
  msg4 = 'Do You really want to replace';  //Modified by JW(2023-05-17):RNDS116 #57, change confirmation message when save project with different name
  msg5 = 'Do You really want to save the changes'; //Modified by JW(2023-05-17):RNDS116 #57, change confirmation message when save project with different name
  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end
  autoSave = false;
  //Modified by PS(2023-01-09): Requested by Ulf(2022-12) : LCC3.0 - Auto save the project and name it 'last project' when click to back to home link-END

  ngOnInit(): void {
    this.autoSave = false;//Modified by PS(2023-01-05): Requested by Ulf(2022-12) : LCC3.0 - Auto save the project and name it 'last project' when click to back to home link-START
  }

  ngOnDestroy() {
    var abc = 123;
  }

  public decline() {
    this.activeModal.close(false);
  }

  public acceptORI() {
    if (this.message === 'Do you really want to insert changes?' || this.message === 'Do you really want to save the project?' || this.message === 'Project Already Exist. Overwrite?') {
      this.ProceedSaveToDb();
    } else {
      this.activeModal.close(true);
    }
  }

  public accept() {
    //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
    //if (this.message === this.msg2 || this.message === this.msg3) {
    if (this.message === this.msg2 || this.message === this.msg3 || this.message.includes(this.msg4) || this.message.includes(this.msg5)) {
      this.ProceedSaveToDb();
    } else {
      this.activeModal.close(true);
    }
  }

  public dismissORI() {
    this.activeModal.dismiss();
  }

  public dismiss(from) {
    if (this.message === this.msg1 && from === 'btn') {
      this.autoSave = true;
      this.ProceedSaveToDb();
    } else {
      this.activeModal.dismiss();
    }
  }

  ProceedSaveToDb() {
    this.saving = true;
    let blnValidEntries = this.sharedService.ValidateDataEntries(this.projectService.projectdetails);
    if (blnValidEntries === true) {
      let CurrentFolderID = this.sharedService.currentFolderID;
      this.projectService.projectdetails.projectInfo.folderId = CurrentFolderID;
      //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
      // if(this.sharedService.projectEditName === ''){
      //   this.sharedService.projectEditName = this.projectService.projectdetails.projectInfo.projectName;
      // }
      // this.projectService.projectdetails.projectInfo.projectName = this.sharedService.projectEditName;
      if (this.sharedService.headerProjectName === '') {
        this.sharedService.headerProjectName = this.projectService.projectdetails.projectInfo.projectName;
      }
      this.projectService.projectdetails.projectInfo.projectName = this.sharedService.headerProjectName;
      //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end
      if (this.autoSave === true) {
        if (this.projectService.projectdetails.projectInfo != undefined) {
          this.projectService.projectdetails.projectInfo.projectName = 'Last project - auto save';
          this.projectService.projectdetails.projectInfo.folderId = 0;
          this.projectService.projectdetails.projectInfo.id = 0;
        } else {
          this.projectService.projectdetails.ProjectName = 'Last project - auto save';
        }
      }

      this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
      var continueUploading = true;
      this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, 'UPLOAD MCCLD PARAMS TO SERVER');
      this.PrepareToUploadParams();
    } else {
      this.toast.warning("Unable to save the project. Please check " + this.sharedService.errPage, "");
    }
  }

  PrepareToUploadParams() {
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res => {
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
        if (res) {
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PrepareToUploadParams();
          } else {
            if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
              this.projectService.SaveProjectToDb().subscribe(result => {
                if (result !== undefined) {

                  this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SAVECALCULATION').subscribe(result => {                       
                    if (result) {}
                  });

                  let successMsg = "Project saved successfully";
                  let failedMsg = "Failed to save the current project to Database!";

                  let tmp: any = result;
                  let aryResults: any = tmp.split(";");
                  let successSave = false;
                  if (aryResults.length > 1) {
                    if (aryResults[0] !== '' && aryResults[0] !== '0' && aryResults[1] === 'Save Db successful.') {
                      successSave = true;
                    }
                  }
                  this.activeModal.close(true);
                  if (successSave) {
                    if (this.autoSave === false) {
                      this.toast.success(successMsg);
                    }
                  } else {
                    if (this.autoSave === false) {
                      this.toast.error(failedMsg);
                    }
                  }

                  if (this.autoSave === true) {
                    this.sharedService.FinishedAutoSaveToDB = true;
                  }

                  if (this.message === this.msg1) {
                    this.router.navigate(["home"]);
                  }
                }
                this.saving = false;
              });
            } else {
              this.toast.error('Failed to upload Parameters for Calculation. TotalPass <> TotalSeq.', '');
              this.activeModal.close(true);
              this.saving = false;
            }
          }
        } else {
          this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
          this.sharedService.UploadingEntry = false;
          this.sharedService.ServerDataReady = false;
          this.saving = false;
        }
      },
      err => {
        this.toast.error('Failed to upload Parameters.Please try again.', '');
        this.activeModal.close(true);
        this.saving = false;
      }
    );
  }
}
